import { compose, curry, map, prop } from 'ramda';
import { createSelector } from 'reselect';

import { filterFalsy } from 'yafrpl/arrays';
import { getDomain } from '../helpers/root';
import { getUrlFromDocument } from '../helpers/routes/mapping';

import { getLocale } from './i18n';

export const getEntities = prop('entities');

const getLocalizedEntities = (state) =>
  compose(prop(getLocale(state)), getEntities)(state);

export const getEntitiesOfType = curry((type, state) =>
  compose(prop(type), getLocalizedEntities)(state)
);

export const getDocById = curry((type, id, state) =>
  compose(prop(id), getEntitiesOfType(type))(state)
);

export const getSingleTypeDoc = curry((type, state) =>
  getDocByUid(type, type, state)
);

export const getDocByUid = curry((type, uid, state) =>
  compose(
    (id) => (id ? getDocById(type, id, state) : null),
    prop(uid),
    prop(type),
    prop('uids'),
    getLocalizedEntities
  )(state)
);

export const getDocsByIds = curry((state, docs) =>
  compose(
    filterFalsy,
    map(({ id, type }) => id && type && getDocById(type, id, state))
  )(docs)
);

export const getDocsByUids = curry((state, docs) =>
  compose(
    filterFalsy,
    map(({ uid, type }) => uid && type && getDocByUid(type, uid, state))
  )(docs || [])
);

export const getHierarchy = createSelector(
  [getDocById, (type, id, state) => state],
  (doc, state) => {
    let hierarchy = [];
    if (doc) {
      hierarchy = [
        {
          name: doc.title || doc.meta?.title,
          item: `${getDomain()}${getUrlFromDocument(doc)}`,
        },
      ];

      if (doc.breadcrumbParent) {
        hierarchy = [
          ...getHierarchy(
            doc.breadcrumbParent.type,
            doc.breadcrumbParent.id,
            state
          ),
          ...hierarchy,
        ];
      }
    }
    return hierarchy;
  }
);
